// src/components/CheckSoccerPredictions.js
import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';

const CheckSoccerPredictions = () => {
  const navigate = useNavigate();
  const { t } = useContext(LanguageContext);

  const handleNormalPredictions = () => {
    navigate('/predictions')
  };

  const handleHighOddsGpt = () => {
    navigate('/soccer-high-odds')
  };

  return (
    <div className="flex flex-col w-full max-w-[400px] mx-auto space-y-3">
      {/* Button 1: Normal Predictions */}
      <button
        onClick={handleNormalPredictions}
        className="bg-[#27ae60] text-white text-center font-bold py-2 rounded shadow hover:bg-green-600 transition"
      >
        {/* //VEZI TOATE PREDICTIILE NORMALE */}
        {t('txt.soccerNormalOdds')}
      </button>

      {/* Button 2: High Odds GPT */}
      <button
        onClick={handleHighOddsGpt}
        className="bg-[#27ae60] text-white text-center font-bold py-2 rounded shadow hover:bg-green-600 transition"
      >
        {/* //VEZI TOATE PREDICTIILE MARI */}
       {t('txt.soccerHighOdds')}
      </button>
    </div>
  );
};

export default CheckSoccerPredictions;
